import { ISerologyTracking } from '@nkr/models/index';
import { Button, Col, Modal, Row, Well } from 'react-bootstrap'

interface IProps {
    show: boolean,
    data: ISerologyTracking,
    onConfirm: () => void,
    onCancel: () => void
}

const CancelConfirm = (props: IProps) => {
    let donorCenter = props.data != null ? props.data.donorCenter : '';
    let donorAlias = props.data != null ? props.data.donorAlias : '';
    let swap = props.data != null ? `${props.data.chainNumber}/${props.data.clusterNumber}/${props.data.positionNumber}` : '';

    console.log(props)

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>Confirm Cancel</Modal.Header>
            <Modal.Body>
                <Well bsSize='sm' style={{ marginBottom: 0 }}>
                    <div style={{ marginBottom: 15 }}>Please confirm that you would like to cancel the following serology...</div>

                    <Row>
                        <Col xs={12} lg={3}>Donor Center:</Col>
                        <Col xs={12} lg={9}>{donorCenter}</Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={3}>Donor Alias:</Col>
                        <Col xs={12} lg={9}>{donorAlias}</Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={3}>Swap:</Col>
                        <Col xs={12} lg={9}>{swap}</Col>
                    </Row>
                </Well>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Confirm</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CancelConfirm;